import { Component, Inject, InjectionToken } from '@angular/core';

export const CHANGELOG_URL = new InjectionToken<string>('changelog_url');

@Component({
  selector: 'app-changelog',
  templateUrl: './changelog.component.html',
  styleUrls: ['./changelog.component.scss'],
})
export class ChangelogComponent {
  url = 'assets/changelogs/changelog.md';

  constructor(@Inject(CHANGELOG_URL) injectedUrl: string) {
    this.url = injectedUrl;
  }
}
